const recruiterLiteProfile = [
    '#experience-card', // Contact Page
];
const recruiterLiteBulk = [
    '.profile-list-item.hp-core-temp', // Bulk Search Page
];
export const LINKEDIN_RECRUITER_LITE_INDICATORS_BY_CONTEXT_TYPE = {
    profile: recruiterLiteProfile,
    bulk: recruiterLiteBulk,
    unknown: [...recruiterLiteProfile, ...recruiterLiteBulk],
};
